import React from "react";
import { useLanguage } from "../../hooks/useLanguage";

interface MenuSectionProps {
  title: string;
  items: {
    name: { [key: string]: string | number | undefined };
    description: { [key: string]: string };
    price: number;
  }[];
}

export default function MenuSection({ title, items }: MenuSectionProps) {
  const { language } = useLanguage();

  // Sort items by price in ascending order
  const sortedItems = [...items].sort((a, b) => a.price - b.price);

  return (
    <div className="mb-16 p-8 glass-card rounded-2xl shadow-xl">
      <h3 className="text-3xl font-bold mb-8 text-primary dark:text-[var(--color-primary)] border-b-2 border-accent pb-2 inline-block">
        {title}
      </h3>
      <div className="flex justify-between items-center mb-6"></div>
      <div className="grid gap-6 md:grid-cols-1 lg:grid-cols-1">
        {sortedItems.map((menuItem, index) => (
          <div
            key={index}
            className="flex flex-col p-5 bg-white/80 dark:bg-[var(--color-bg-card)] backdrop-blur-sm rounded-xl shadow-md hover-lift border border-gray-100 dark:border-gray-700"
          >
            <h4 className="text-lg font-semibold text-gray-900 dark:text-[var(--color-text-base)] mb-2">
              {menuItem.name[language]}
            </h4>
            <p className="text-gray-700 dark:text-[var(--color-text-muted)] mb-4">
              {menuItem.description[language]}
            </p>
            <div className="self-end mt-auto">
              <span className="bg-gradient-to-r from-primary to-secondary text-white font-semibold py-1 px-3 rounded-full shadow-sm whitespace-nowrap">
                €{menuItem.price.toFixed(2)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
